import { cx } from '@linaria/core';
import { switchDiv, disabledStyles, round } from './Switch.styles';

export interface SwitchProps extends React.HTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
  labelPlacement?: 'left' | 'right';
  isActive: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Switch = ({ className, isActive, onChange, label, disabled, labelPlacement = 'right', ...rest }: SwitchProps): JSX.Element => (
  <label className={cx(switchDiv, disabled && disabledStyles, className)} role="presentation">
    {Boolean(label) && labelPlacement === 'left' && <div className="label-text-left">{label}</div>}
    <input
      tabIndex={0}
      type="checkbox"
      checked={isActive}
      aria-checked={isActive}
      onChange={onChange}
      disabled={disabled}
      className="input"
      {...rest}
    />
    <div className={cx('slider', round)}>
      <div className={cx('thumb', round)} />
    </div>
    {Boolean(label) && labelPlacement === 'right' && <div className="label-text-right">{label}</div>}
  </label>
);
